var __rspack_ns_object = JSON.parse('{"Copied":"Copied","Failed to copy":"Failed to copy"}')